import { Checkbox, Loader, Popup } from 'semantic-ui-react';
import { Row } from 'react-table';
import { useMonitoringTableContext } from './useMonitoringTableContext';
import styled from '@emotion/styled';
import { useState } from 'react';

export interface FollowUpCellProps<
  TData extends {
    id: number;
    hasFollowUp: boolean;
  },
> {
  row: Row<TData>;
  isDisabled?: (data: TData) => boolean;
  disabledMessage?: string;
}

export const FollowUpCell = <
  TData extends {
    id: number;
    hasFollowUp: boolean;
  },
>({
  row,
  isDisabled,
  disabledMessage = 'Follow-up cannot be added for this record',
}: FollowUpCellProps<TData>) => {
  const { onUpdateFollowUp } = useMonitoringTableContext();
  const [localLoading, setLocalLoading] = useState(false);

  const disabled = isDisabled ? isDisabled(row.original) : false;

  const handleChange = async (
    _: React.FormEvent<HTMLInputElement>,
    data: { checked?: boolean }
  ) => {
    setLocalLoading(true);
    try {
      await onUpdateFollowUp?.({ id: row.original.id, hasFollowUp: !!data.checked });
    } finally {
      setLocalLoading(false);
    }
  };

  return (
    <S.CheckboxContainer>
      {localLoading ? (
        <Loader active={localLoading} />
      ) : (
        <Popup
          disabled={!disabled}
          trigger={
            <Checkbox
              checked={row.original.hasFollowUp}
              disabled={disabled}
              onChange={handleChange}
              loading={true}
            />
          }
          content={disabledMessage}
          position="left center"
        />
      )}
    </S.CheckboxContainer>
  );
};

const S = {
  CheckboxContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  `,
};
